import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import Slider from 'react-slick';
import { timingFunctions, rgba } from 'polished';
import $ from 'domtastic';

import Cell from './cell';
import { settingsFriends, gap, growFactor } from './constants';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { colors } from '../../styles/theme';

import Chevron from '../../images/chevron.svg';

// const isEmpty = thing => (!thing || thing === '');
// const defaultColor = color => (isEmpty(color) ? '#fff' : color);

// function isElementInViewport(el) {
//   const rect = el.getBoundingClientRect();
//   return (
//     rect.top >= 0
//     && rect.left >= 0
//     && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
//     && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
//   );
// }

function isAnyPartOfElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
  // const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  // const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const bodyWidth = document.body.clientWidth;

  // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
  // const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
  const horInView = rect.left < bodyWidth && rect.left + rect.width > 0;

  // return (vertInView && horInView);
  return horInView;
}

export default class Grid extends React.Component {
  constructor(props) {
    super(props);

    this.cellWidthSet = false;
  }

  state = {
    windowWidth: null,
    cellWidth: null,
    cellMounted: false,
    firstHovered: false,
    lastHovered: false,
  }

  componentDidMount() {
    this.setWindowWidth();
    $(window).on('resize', this.setWindowWidth);
  }

  componentWillUnmount() {
    $(window).off('resize', this.setWindowWidth);
    this.destroyEvents();
  }

  componentDidUpdate() {
    this.setCellWidth();
  }

  setWindowWidth = () => {
    this.setState({ windowWidth: window.innerWidth });
    setTimeout(() => {
      this.setCellWidth(true);
      this.afterChange();
    }, 300);
  }

  setCellWidth(force = false) {
    if (!this.cellWidthSet || force) {
      const firstSlide = $(this.el).find('.slick-slide')[0];
      if (firstSlide) {
        const { width } = firstSlide.getBoundingClientRect();
        if (this.state.cellWidth !== width) {
          this.setState({ cellWidth: width }) // eslint-disable-line
          this.afterChange();
          this.cellWidthSet = true;
        }
      }
    }
  }

  setCellMounted = (mounted) => {
    this.setState({ cellMounted: mounted });
  }

  setupEvents() {
    if (this.props.zoomSlide) {
      const slides = $(this.el).find('.slick-slide');
      slides.forEach((el) => {
        if (isAnyPartOfElementInViewport(el)) {
          el.classList.add('in-view');
        } else {
          el.classList.remove('in-view');
        }
      });

      const activeSlides = $(this.el).find('.slick-slide.in-view');
      if (activeSlides.length) {
        $(activeSlides[0]).on('mouseenter', this.mouseOverFirst);
        $(activeSlides[0]).on('mouseleave', this.mouseLeaveFirst);
        $(activeSlides[activeSlides.length - 1]).on('mouseenter', this.mouseOverLast);
        $(activeSlides[activeSlides.length - 1]).on('mouseleave', this.mouseLeaveLast);
      }
    }
  }

  destroyEvents() {
    if (this.props.zoomSlide) {
      const allSlides = $(this.el).find('.slick-slide');
      allSlides.forEach((el) => {
        $(el).off('mouseenter', this.mouseOverFirst);
        $(el).off('mouseleave', this.mouseLeaveFirst);
        $(el).off('mouseenter', this.mouseOverLast);
        $(el).off('mouseleave', this.mouseLeaveLast);
      });
    }
  }

  afterChange = () => {
    this.destroyEvents();
    this.setupEvents();
  }

  mouseOverFirst = () => {
    this.setState({ firstHovered: true });
  }

  mouseLeaveFirst = () => {
    this.setState({ firstHovered: false });
  }

  mouseOverLast = () => {
    this.setState({ lastHovered: true });
  }

  mouseLeaveLast = () => {
    this.setState({ lastHovered: false });
  }

  render() {
    const {
      data, render, style, zoomSlide = false, slickSettings = settingsFriends
    } = this.props;
    const {
      windowWidth, cellWidth, firstHovered, lastHovered
    } = this.state;

    return (
      <Outer>
        <Inner
          count={data.length}
          cellWidth={cellWidth}
          innerRef={(el) => {
            this.el = el;
          }}
          zoomSlide={zoomSlide}
          firstHovered={firstHovered}
          lastHovered={lastHovered}
        >
          <Slider
            {...slickSettings}
            afterChange={this.afterChange}
            prevArrow={<Arrow />}
            nextArrow={<Arrow type="next" />}
            ref={(el) => {
              this.slider = el;
            }}
          >
            {windowWidth
              && data.map(item => (
                <Cell
                  key={item.id}
                  item={item}
                  gap={gap}
                  render={render}
                  cellMounted={this.setCellMounted}
                  cellWidth={cellWidth}
                />
              ))}
          </Slider>
        </Inner>
      </Outer>
    );
  }
}

const Outer = styled.div`
  padding: 0 ${gap}px 2rem;
`;

const innerStyles = (p) => {
  let left = -p.cellWidth / 2;
  if (p.firstHovered) {
    left = 0;
  }
  if (p.lastHovered) {
    left = -p.cellWidth;
  }

  return css`
    .slick-track {
      margin: 0;
      position: relative;
      display: flex;
      transition: left 0.4s ${timingFunctions('easeInOutQuart')};

      ${p.zoomSlide
        && `
        @media (min-width: 481px) {
          &:hover {
            left: ${left}px;
          }
        }
      `};
    }

    .slick-dots li button:before {
      opacity: 1;
      color: ${colors.pr.gray300};
      font-size: 10px;
    }

    .slick-dots li.slick-active button:before {
      color: ${colors.primary};
      font-size: 14px;
    }

    .slick-slide {
      flex-shrink: 0;
      float: none;
      transition: all 0.4s ${timingFunctions('easeInOutQuart')};

      & > div > div {
        outline: none;
      }

      ${p.zoomSlide
        && p.cellWidth
        && `
        @media (min-width: 481px) {
          &:hover {
            width: ${p.cellWidth * growFactor}px !important;
          }
        }
      `};
    }

    .slick-prev,
    .slick-next {
      z-index: 100;
    }

    .slick-prev {
      left: 5px;
    }

    .slick-next {
      right: 5px;
    }
  `;
};

const Inner = styled.div`
  ${innerStyles};
`;

const Arrow = ({ onClick, type = 'prev', className }) => (
  <ArrowWrapper className={className} onClick={onClick} type={type}>
    <Chevron
      css={{
        display: 'block',
        width: 30,
        fill: '#fff',
        transform: `scale(${type === 'next' ? '-1' : '1'})`,
        marginLeft: type === 'next' ? 0 : -6,
        marginRight: type !== 'next' ? 0 : -6,
        // '&:hover': {
        //   transform: `scale(${type === 'next' ? '-1.2' : '1.2'})`,
        // }
      }}
    />
  </ArrowWrapper>
);

const ArrowWrapper = styled.div`
  display: block;
  position: absolute;
  top: 50%;
  width: auto !important;
  height: auto !important;
  transform: translateY(-50%);
  left: ${p => (p.type === 'next' ? 'auto' : 0)} !important;
  right: ${p => (p.type !== 'next' ? 'auto' : 0)} !important;
  overflow: hidden;
  cursor: pointer;
  padding: 16px 0;
  background: ${rgba('#000', 0.2)};
  border-radius: ${p => (p.type === 'next' ? '16px 0 0 16px' : '0 16px 16px 0')};
  transition: all 0.2s;

  &.slick-disabled {
    opacity: 0;
    ${'' /* visibility: hidden; */}
    transition: all 0.2s, visibility 0 linear 0.2s;
    cursor: default;
  }

  &:before {
    display: none;
  }

  &:hover {
    background: ${rgba('#000', 0.8)};
  }
`;
